import { CheckCircle2 } from "lucide-react";

export const InFollowUpsTag = ({ testid }) => (
  <span className="inline-flex shrink-0 items-center gap-1 rounded-full border border-emerald-500/40 bg-emerald-500/10 px-2 py-0.5 text-[10px] font-medium text-emerald-300" title="Already in LinkedIn Follow-ups" data-testid={testid}>
    <CheckCircle2 className="h-3 w-3" />In Follow-ups
  </span>
);
